import { ValidationArguments, ValidatorConstraint, ValidatorConstraintInterface, ValidationOptions, registerDecorator } from 'class-validator';

@ValidatorConstraint()
export class TenantDetailsIsMpnIdValidConstraint implements ValidatorConstraintInterface {

  validate(value: string, validationArguments: ValidationArguments) {
    const isMpnValid: boolean = (validationArguments.object as any)[validationArguments.constraints[0]];
    const isMpnValidating: boolean = (validationArguments.object as any)[validationArguments.constraints[1]];
    const isMpnValidated: boolean = (validationArguments.object as any)[validationArguments.constraints[2]];

    // If attempting to validation skip this constraint
    if (isMpnValidating || isMpnValidated) {
      return true;
    }

    return value && value.length > 0 ? isMpnValid : true;
  }
}

export function TenantDetailsIsMpnIdValid(isMpnValid: string, isMpnValidating: string, isMpnValidated: string, validationOptions?: ValidationOptions) {
  return (object: any, propertyName: string) => {
    registerDecorator({
      target: object.constructor,
      propertyName,
      options: validationOptions,
      constraints: [isMpnValid, isMpnValidating, isMpnValidated],
      validator: TenantDetailsIsMpnIdValidConstraint,
    });
  };
}
